import { LINK_OF_ALL_PAGES } from "const/common";
const ENTERPRISE_SOFTWARE_SOLUTION = "Enterprise Software Solution";
const CLOUD_DEVELOPMENT = "Cloud And DevOps";
const MOBILE_APP_DEVELOPMENT = "Mobile App Development";
const WEB_DEVELOPMENT = "Web Development";
const UI_UX_DESIGN = "UI/UX Design";

export const CUSTOM_SOFTWARE_URL =
  "https://ultroneous.com/custom-software-development";
export const CUSTOM_SOFTWARE_DETAIL =
  "ultroNeous Technologies is a Top-notch Custom software development services provider in India, USA.Our expert team can help you create the next generation of  software offerings.";
export const CUSTOM_SOFTWARE_TITLE =
  "Custom Software Development Services | ultroNeous Technologies";

export const CUSTOM_SOFTWARE_INNER_PAGES_DATA = [
  {
    heading: WEB_DEVELOPMENT,
    details:
      "Our team builds custom web solutions rooted in your vision and goals. We cooperate with you through multiple business models and operate in various domains like FinTech, e-Commerce, Healthcare and more. ",
    image: "/assets/services/custom-software/web-development.webp",
    alt: WEB_DEVELOPMENT,
    title: WEB_DEVELOPMENT,
    list: ["MERN Stack", "MEAN Stack", "Open Source", "LAMP Stack"],
    link: LINK_OF_ALL_PAGES.services.webApplicationDevelopmentServices,
    value: "View More",
  },
  {
    heading: MOBILE_APP_DEVELOPMENT,
    details:
      "When you want an advanced mobile app developed with high speed loading in mind, our mobile software developers possess the technical expertise you need. Be it taking care of the mobile UI or optimizing the API integration; we have a solution for you.",
    image: "/assets/services/custom-software/mobile-app-development.webp",
    alt: MOBILE_APP_DEVELOPMENT,
    title: MOBILE_APP_DEVELOPMENT,
    list: [
      "App UI Creation",
      "API Integration",
      "Native iOS/ Android Development",
      "Cross-platform App Development",
    ],
    link: LINK_OF_ALL_PAGES.services.mobileApplicationDevelopmentServices,
    value: "View More",
  },
  {
    heading: UI_UX_DESIGN,
    details:
      "With a conceptual user-centric approach, we help you build a creative design solution that reflects your brand's values, benefits multiple user roles, and eliminates bottlenecks with web & mobile app designs.",
    image: "/assets/services/custom-software/ui-ux-design.gif",
    alt: UI_UX_DESIGN,
    title: UI_UX_DESIGN,
    list: [
      "Design Research and Analysis",
      "Wireframing and Prototyping",
      "Multiplatform UX Design",
      "Web and Mobile app UI",
    ],
    link: LINK_OF_ALL_PAGES.services.uiUXDesignServices,
    value: "View More",
  },
  {
    heading: CLOUD_DEVELOPMENT,
    details:
      "We help setting up your server and infrastructure, taking care of your cloud server and operations to enable near-instantaneous deployment of products and services in the cloud, having strong expertise in cloud computing.  ",
    image: "/assets/services/custom-software/cloud-and-devops.webp",
    alt: CLOUD_DEVELOPMENT,
    title: CLOUD_DEVELOPMENT,
    list: [
      "Cloud-Native Development",
      "Cloud Software Re-architecting",
      "Cloud Security Assurance",
      "Cloud Migration",
    ],
    link: LINK_OF_ALL_PAGES.services.cloudAndDevopsServices,
    value: "View More",
  },
  {
    heading: ENTERPRISE_SOFTWARE_SOLUTION,
    details:
      "Whether building a bespoke enterprise app or reengineering your legacy product, with our wide-ranging custom software development services you can become an international leader driven by innovation and automation.",
    image: "/assets/services/custom-software/enterprise-software-solution.webp",
    alt: ENTERPRISE_SOFTWARE_SOLUTION,
    title: ENTERPRISE_SOFTWARE_SOLUTION,
    list: [
      "Custom Enterprise Software Development",
      "Enterprise Data Management",
      "Legacy Application Modernization",
      "Software Maintenance & Support",
    ],
    link: LINK_OF_ALL_PAGES.services.enterpriseSoftwareDevelopmentServices,
    value: "View More",
  },
];
export const VALUE_SECTION_DATA = [
  {
    image: "/assets/services/custom-software/domain-expertise.webp",
    alt: "Exceptional Domain Expertise",
    title: "Exceptional Domain Expertise",
    description:
      "Being a custom software development firm, we have experts in niche technologies who have worked in diverse industries, allowing us to anticipate issues and maintain quality.",
  },
  {
    image: "/assets/services/custom-software/comprehensive-approach.webp",
    alt: "A Comprehensive Approach",
    title: "A Comprehensive Approach",
    description:
      "We implement the software development cycle holistically by covering all aspects of design, integration, and safety, from ideation to implementation.",
  },
  {
    image: "/assets/services/custom-software/procedural-transparency.webp",
    alt: "Procedural Transparency",
    title: "Procedural Transparency",
    description:
      "The whole custom software development process is backed by proven project management tools, open communication, constant feedback, and timely reports, so you always stay updated. ",
  },
  {
    image: "/assets/services/custom-software/deadline-estimation.webp",
    alt: "Realistic Deadline Estimation",
    title: "Realistic Deadline Estimation",
    description:
      'When gauging the project span; we consider complexity,<a href="/ui-ux-design-services"> UI/UX Design Services</a>, tech stack integration and divide it into clearly-defined stages so you can launch in the market with confidence.',
  },
  {
    image: "/assets/services/custom-software/impeccable-results.webp",
    alt: "Impeccable Results",
    title: "Impeccable Results",
    description:
      "Yes, we know how valuable custom-built software can be. So we take care of your budget and time and scan every detail to make sure the quality of end results remains top-notch.",
  },
  {
    image: "/assets/services/custom-software/security-oriented.webp",
    alt: "Security-oriented Architecture",
    title: "Security-oriented Architecture",
    description:
      "Our software developers implement procedures to protect data from cyberattacks and ensure everything aligns with your business goals from the early stages.",
  },
];
export const CUSTOM_SOFTWARE_FAQ_DATA = [
  {
    question: "What is custom software development?",
    answer:
      "Customer Software development is a process of creating unique software solutions and is set to solve problems for specific users. Generally, speaking custom software development process includes multiple steps like design, development, testing, deliveries, maintenance & support.",
  },
  {
    question: " How many types of custom software development are there?",
    answer:
      "There are typically 6 types of Custom Software Development that include Enterprise Software Solutions, E-commerce Software, Enterprise Resource Planning Systems, Content Management Systems, Customer Relationship Managers & Operating Management Software.",
  },
  {
    question:
      "What is the difference between off-the-shelf software and custom software development?",
    answer:
      "Off-the-shelf software is readily available for general usage while custom software means a bespoke development tailored as per clients' needs.",
  },
  {
    question: "What kind of organization needs custom software development?",
    answer:
      'There is no classification as to which organization wants upgradation or is starting from scratch and the companies searching for tailored solutions can take leverage of our custom <a href="https://ultroneous.com/"> software development Services</a>.',
  },
  {
    question:
      "What is the development process used by ultroNeous for its clients?",
    answer:
      "ultroNeous uses a bespoke development process based on clients' requirements. But generalizing the statement our experts at the initial stage conceptualize the idea and then start planning, analysis, design after the initial 4 steps start development and testing. Once it's a go-ahead then come launch and support.",
  },
  {
    question: " How much time does it take to build custom software?",
    answer:
      "The duration is completely dependent upon the size and complexity of the project. Our team gives an estimation once all the requirements from the client ends are clear and thorough research is conducted. ",
  },
  {
    question: "Why hire a custom software development company?",
    answer:
      'The main aim of hiring a custom software development company is to get an idea about what works best for your company. Once you <a href="https://ultroneous.com/contact-us"> hire us </a> our experts provide tailored recommendations and suggestions based on the industry niche.',
  },
  {
    question: "How can custom software development company help startups?",
    answer:
      "Hiring a custom software company like ultroNeous Technologies will help startups in multiple ways to name a few fewer complexities, easy system integration, personalized experiences, and more.",
  },
];
export const CUSTOM_SOFTWARE_SCHEMA = {
  customeBreadcrumb: {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        item: {
          "@id": "https://ultroneous.com/",
          name: "ultroNeous Technologies",
        },
      },
      {
        "@type": "ListItem",
        position: 2,
        item: {
          "@type": "WebPage",
          "@id": "https://ultroneous.com/services",
          url: "https://ultroneous.com/services",
          name: "services",
        },
      },
      {
        "@type": "ListItem",
        position: 3,
        item: {
          "@type": "WebPage",
          "@id": CUSTOM_SOFTWARE_URL,
          url: CUSTOM_SOFTWARE_URL,
          name: "custom software development company",
        },
      },
    ],
  },
  faqs: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What is custom software development?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Customer Software development is a process of creating unique software solutions and is set to solve problems for specific users. Generally, speaking custom software development process includes multiple steps like design, development, testing, deliveries, maintenance & support.",
        },
      },
      {
        "@type": "Question",
        name: "How many types of custom software development are there?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "There are typically 6 types of Custom Software Development that include Enterprise Software Solutions, E-commerce Software, Enterprise Resource Planning Systems, Content Management Systems, Customer Relationship Managers & Operating Management Software.",
        },
      },
      {
        "@type": "Question",
        name: "What is the difference between off-the-shelf software and custom software development?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Off-the-shelf software is readily available for general usage while custom software means a bespoke development tailored as per clients' needs.",
        },
      },
      {
        "@type": "Question",
        name: "What kind of organization needs custom software development?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "There is no classification as to which organization wants upgradation or is starting from scratch and the companies searching for tailored solutions can take leverage of our custom software development",
        },
      },
      {
        "@type": "Question",
        name: "What is the development process used by ultroNeous for its clients?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "ultroNeous uses a bespoke development process based on clients' requirements. But generalizing the statement our experts at the initial stage conceptualize the idea and then start planning, analysis, and design after the initial 4 steps start development and testing. Once it's a go-ahead then come launch and support.",
        },
      },
      {
        "@type": "Question",
        name: "How much time does it take to build custom software?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The duration is completely dependent upon the size and complexity of the project. Our team gives an estimation once all the requirements from the client ends are clear and thorough research is conducted.",
        },
      },
      {
        "@type": "Question",
        name: "Why hire a custom software development company?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The main aim of hiring a custom software development company is to get an idea about what works best for your company. Once you hire us our experts provide tailored recommendations and suggestions based on the industry niche.",
        },
      },
      {
        "@type": "Question",
        name: "How can custom software development company help startups?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Hiring a custom software company like ultroNeous Technologies will help startups in multiple ways to name a few fewer complexities, easy system integration, personalized experiences, and more.",
        },
      },
    ],
  },
};
